export const SFAPI_VERSION = '2025-10';
